import type { AxiosInstance } from 'axios'
import { apiGatewayDarwinAxiosInstance, darwinAxiosInstance } from '@nic/nic-api'
import type { NicScope } from '@nic/nic-api/types'

export interface RequestDomainSearchRevision {
  first: number
  last: number
}

export interface RequestDomainSearchResult {
  contactId: number
  dbnaId: number
  domain: string
  id: number
  registrarContactId: string
  requestId: number
  status: string
  revision?: RequestDomainSearchRevision
}

export interface RequestDomainSearchPagination {
  number: number
  size: number
  totalElements: number
  totalPages: number
}

export interface RequestDomainSearchResponse {
  elements: RequestDomainSearchResult[]
  page: RequestDomainSearchPagination
}

const DARWIN_DOMAINS_PATH = '/domains'

export const getRequestSearchHttpClient = (scope: NicScope): AxiosInstance => {
  return scope === 'registrar' ? apiGatewayDarwinAxiosInstance : darwinAxiosInstance
}

const normalizeDomain = (domain: string): string => domain.trim().toLowerCase()

export const searchRequestByDomain = async (
  domain: string,
  scope: NicScope,
): Promise<RequestDomainSearchResponse> => {
  const normalizedDomain = normalizeDomain(domain)

  if (!normalizedDomain) {
    throw new Error('Domain name is required')
  }

  const httpClient = getRequestSearchHttpClient(scope)

  const response = await httpClient.get<RequestDomainSearchResponse>(DARWIN_DOMAINS_PATH, {
    params: { domain: normalizedDomain },
  })

  return response.data
}

export const findRequestByDomain = async (
  domain: string,
  scope: NicScope,
): Promise<RequestDomainSearchResult | undefined> => {
  const data = await searchRequestByDomain(domain, scope)
  return data.elements.find((element) => element.domain.toLowerCase() === normalizeDomain(domain))
} 
